import React from 'react';
import './spiner.css'; // Импортируйте CSS файл

export default function Spiner(){
  return (
    <> 
       <div className="spinner-container">
      <div className="loader"></div>
    </div>
    </>

  );
};
